import { render, staticRenderFns } from "./App.vue?vue&type=template&id=1dfb196b&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "@/assets/styles/variables.css?vue&type=style&index=0&lang=css&"
import style1 from "@/assets/styles/global.css?vue&type=style&index=1&lang=css&"
import style2 from "@/assets/styles/fonts.scss?vue&type=style&index=2&lang=scss&"
import style3 from "./App.vue?vue&type=style&index=3&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports